import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/home/Hero";
import ServicesGrid from "@/components/home/ServicesGrid";
import EcoSection from "@/components/home/EcoSection";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import CTASection from "@/components/home/CTASection";
import SEOHead from "@/components/seo/SEOHead";
import StructuredData from "@/components/seo/StructuredData";
import ReviewsSection from "@/components/common/ReviewsSection";
import ZoneIntervention from "@/components/common/ZoneIntervention";

const Index = () => {
  const organizationData = {
    "@type": "LocalBusiness",
    name: "EPP Espaces Paysages & Propreté",
    legalName: "EPP SARL",
    url: "https://espacespaysagesproprete.fr",
    logo: "https://espacespaysagesproprete.fr/logo-epp-new.webp",
    foundingDate: "2015-09",
    description: "Entreprise de nettoyage professionnel et d'entretien d'espaces verts à Nantes depuis 2015",
    address: {
      "@type": "PostalAddress",
      streetAddress: "2 rue Robert-le-Ricolais",
      addressLocality: "Nantes",
      postalCode: "44300",
      addressCountry: "FR"
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "47.2184",
      longitude: "-1.5536"
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+33-7-69-63-87-77",
      contactType: "customer service",
      areaServed: "FR",
      availableLanguage: "French"
    },
    priceRange: "€€",
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "18:00"
      }
    ],
    sameAs: [],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      reviewCount: "45"
    },
    areaServed: [
      { "@type": "City", name: "Nantes" },
      { "@type": "City", name: "Saint-Herblain" },
      { "@type": "City", name: "Rezé" },
      { "@type": "City", name: "Orvault" },
      { "@type": "City", name: "Vertou" },
      { "@type": "City", name: "Carquefou" },
      { "@type": "City", name: "Bouguenais" }
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Services de nettoyage professionnel",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Nettoyage de vitrerie" }
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Entretien de bureaux" }
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Entretien d'espaces verts" }
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Nettoyage industriel" }
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Nettoyage de façades" }
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Nettoyage de boutiques" }
        }
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead 
        title="Nettoyage Professionnel Nantes | EPP - Devis Gratuit 44"
        description="EPP : Expert en nettoyage professionnel à Nantes depuis 2015. Vitrerie, façades, bureaux, espaces verts, industriel. Devis gratuit en Loire-Atlantique. ☎️ 07 69 63 87 77"
        canonical="https://espacespaysagesproprete.fr/"
        keywords="nettoyage professionnel Nantes, entretien bureaux, nettoyage vitrerie, façades Nantes, espaces verts, EPP"
      />
      <StructuredData type="LocalBusiness" data={organizationData} />
      <Navigation />
      <main>
        <Hero />
        <ServicesGrid />
        <WhyChooseUs />
        <ZoneIntervention />
        <ReviewsSection />
        <EcoSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
